import { render, staticRenderFns } from "./returnGoodslistOld.vue?vue&type=template&id=82502a42&scoped=true"
import script from "./returnGoodslistOld.vue?vue&type=script&lang=js"
export * from "./returnGoodslistOld.vue?vue&type=script&lang=js"
import style0 from "./returnGoodslistOld.vue?vue&type=style&index=0&id=82502a42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82502a42",
  null
  
)

export default component.exports